<template>
<!-- 客户分析页面 -->
  <div>
    <div class="commonFilter">
      <div class="card-container">
        <div class="card-content">
          <Form ref="pageParams" :model="pageParams" :label-width="100" label-position="right">
            <div class="platformParamsSelect">
              <Form-item :label="$t('common.deliveryDate') + '：'" prop="deliveryDate ">
                <Date-picker :value="deliveryDate" :clearable="clearAble" :options="options2" type="daterange" placement="bottom-end"
                :placeholder="$t('common.selectDate')" style="width:304px" @on-clear="resetDate" @on-change="getDateValue"></Date-picker>
              </Form-item>
            </div>
            <div class="platformParamsSelect">
              <Row>
                <Col span="6">
                  <Form-item :label="$t('common.merchantId') + '：'">
                    <Input v-model.trim="pageParams.merchantId"></Input>
                  </Form-item>
                </Col>
                <Col span="3" push="1">
                  <Button type="primary" @click="search" v-once icon="search">{{$t('common.search')}}</Button>
                </Col>
              </Row>
            </div>
          </Form>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div class="orderTable normalTop">
      <Table highlight-row border :height="tableHeight" :columns="customerColumn" :data="customerData"></Table>
      <div class="table-page">
        <div class="table-page-right">
          <Page :total="total" @on-change="changePage" show-total :page-size="pageParams.pageSize" show-elevator :current="pageParams.pageNum" show-sizer @on-page-size-change="changePageSize" placement="top" :page-size-opts="pageArray"></Page>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
export default {
  mixins: [ Mixin, tableMixin ],
  data () {
    let self = this;
    return {
      pageParams: {
        customerId: '', // 客户ID
        merchantId: '', // 商户编号
        partnerId: '', // 合作伙伴编号
        startTime: '',
        endTime: '',
        pageSize: 10,
        pageNum: 1,
        startPos: 0
      },
      pageParamsStatus: false, // 是否重新加载列表数据
      deliveryDate: [], // 发货日期
      customerColumn: [
        {
          title: self.t('common.serialNum'),
          type: 'index',
          width: 70,
          fixed: 'left',
          align: 'center'
        },
        {
          title: self.t('common.merchantId'),
          key: 'merchantId',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.region'),
          key: 'region',
          align: 'center'
        },
        {
          title: self.t('common.companyName'),
          key: 'companyName',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.packageNum'),
          key: 'packageQuantity',
          // sortable: true
          align: 'center',
          render: (h, params) => {
            if (params.row.packageQuantity === null) {
              return '0';
            } else {
              return h('span', params.row.packageQuantity);
            }
          }
        },
        {
          title: self.t('logisticsProvider.cost'),
          key: 'packageCost',
          align: 'center',
          render: (h, params) => {
            if (params.row.packageCost === null) {
              return '0.00';
            } else {
              return h('span', params.row.packageCost);
            }
          }
        }
      ],
      options2: {
        shortcuts: [
          {
            text: self.t('common.lastWeek'),
            value: function () {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            }
          },
          {
            text: self.t('common.lastMonth'),
            value: function () {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            }
          },
          {
            text: self.t('common.last3months'),
            value: function () {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            }
          }
        ]
      },
      customerData: [],
      total: 0, // 总记录数
      clearAble: true
    };
  },
  methods: {
    search () {
      let v = this;
      v.pageParamsStatus = true;
      v.pageParams.pageNum = 1;
    },
    resetDate () {
      let v = this;
      v.pageParams.startTime = null;
      v.pageParams.endTime = null;
    },
    // 获取日期返回值
    getDateValue (value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(v.t('validValue.errorDate'));
        v.resetDate();
      } else {
        if (value[0] === '' || value[0] === null) return false;
        let startTime = v.getUniversalTime(new Date(value[0]).getTime(), 'fulltime');
        let endTime = v.getUniversalTime(new Date(value[1]).getTime(), 'fulltime');
        v.pageParams.startTime = startTime.substring(0, 10);
        v.pageParams.endTime = endTime.substring(0, 10);
      }
    },
    getList () {
      let v = this;
      v.axios.post(api.get_analyze, v.pageParams)
        .then(res => {
          if (res.data.code === 0) {
            v.customerData = res.data.datas.list;
            v.total = res.data.datas.total;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    }
  },
  created () {
    this.tableHeight = this.getTableHeight(452);
    let value = (function () {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      return [start, end];
    })();
    this.deliveryDate = value;
    this.getDateValue(value);
    this.getList();
  },
  watch: {
    pageParamsStatus (n, o) { // 监听重置列表数据
      let v = this;
      if (n) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/customerAnalysis.vue